export function initTestimonialSlider() {
    if (!document.querySelector(".testimonial-swiper")) return;

    new Swiper(".testimonial-swiper", {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });
}
